import { Col, Row } from "antd";
import DatePickerComponent from "../../../components/DatePickerComponent";
import { InputStyle, labelStyle } from "../constants";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { SwitchContainer } from "./styles";
import { useCDNFileContext } from "../../../context/CDNFileContext/CDNFileContext";


const Info = () => {
	const { cdnData, setCDNFileData } = useCDNFileContext();

	const [releaseDate, setReleaseDate] = useState<string>("");

	const handleReleaseDateChange = (dateString: string) => {
		setReleaseDate(dateString);
		setCDNFileData({ ...cdnData, releaseDate: dateString });
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={8}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={cdnData?.displayOrder}
						onChange={(value) => setCDNFileData({ ...cdnData, displayOrder: Number(value) })}
					/>
				</Col>
				<Col span={8}>
					<DatePickerComponent
						title="Yayınlanma Tarihi"
						value={releaseDate ? dayjs(releaseDate) : null}
						onChange={handleReleaseDateChange}
						style={InputStyle}
						isRequired
						disablePastDates
					/>
				</Col>
				<Col span={8}>
					<SwitchContainer>
						<SwitchOptionComponent
							key={"isActive"}
							title={"Görünürlük"}
							labelStyle={labelStyle}
							value={cdnData?.isVisible}
							onChange={(checked) => setCDNFileData({ ...cdnData, isVisible: checked })}
						/>
					</SwitchContainer>
				</Col>
			</Row >
		</>
	);
};

export default Info;
